import React, { useEffect, useState } from "react";
import useSWR from "swr";
import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";

import BasicTable from "../../shared/Table";

const NoBarcodeProducts = ({ showFullData }) => {
  const retailer = useSelector((state) => state.retailer);
  const [page, setPage] = useState(0);
  const [products, setProducts] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const retailerId = retailer?.id;
  const headers = [
    {
      id: "translations.name",
      key: "name",
      name: "Product Name",
      disabled: true,
    },
  ];
  const productsPayload = {
    fields: ["*", "translations.*"],
    filter: showFullData
      ? {
          barcode: {
            _null: true,
          },
        }
      : {
          retailers: {
            retailer_id: {
              id: {
                _eq: retailerId,
              },
            },
          },
          barcode: {
            _null: true,
          },
        },
    limit: -1,
  };

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const { data: productData, isLoading } = useSWR({
    url: `beef_product?page=${page + 1}&meta=*`,
    ...productsPayload,
    limit: rowsPerPage,
  });

  useEffect(() => {
    if (productData) {
      setProducts(productData);
    }
  }, [productData]);

  return (
    <Box
      sx={{
        width: "100%",
        boxShadow: "0 2px 4px rgba(0,0,0,0.5)",
        position: "relative",
        padding: "16px",
        backgroundColor: "#efeeee",
      }}
    >
      <Box
        sx={{
          mb: 2,
        }}
      >
        <Box sx={{ my: 1 }}>
          <Typography
            sx={{
              fontWeight: "bold",
              color: "#090909",
              fontSize: "0.9rem",
              textTransform: "capitalize",
            }}
          >
            Products Without Barcode
          </Typography>
        </Box>

        <Box sx={{ my: 1 }}>
          <Typography
            sx={{
              fontWeight: 300,
              color: "#090909",
              fontSize: "0.8rem",
            }}
          >
            Products can not be found through barcode scanning (Products not
            represented with barcodes)
          </Typography>
        </Box>
      </Box>

      <BasicTable
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        page={page}
        rowsPerPage={rowsPerPage}
        headers={headers}
        items={products?.data
          ?.map(({ translations }) => ({
            name: translations[0]?.name ?? "(Not Provided)",
          }))
          ?.sort((a, b) => a.name.localeCompare(b.name))}
        totalCount={products?.meta?.filter_count}
        isLoading={isLoading}
      />
    </Box>
  );
};

export default NoBarcodeProducts;
